import column from './column/column.component';
import component from './flows.component';
import contact from './contact/contact.component';
import service from './flows.service';
import setup from './setup/setup.component';

export default angular.module('mpdx.contacts.flows', [component, column, contact, service, setup]).name;
